import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import { ResourceTypes } from "@planzone/dto";
import { ResourceAvatar } from "@common/resourceAvatar";
import { VirtualResourceIcon } from "@common/resourceAvatar/virtualResourceIcon";
import { MaterialResourceIcon } from "@common/resourceAvatar/materialResourceIcon";
import { RemoveIcon } from "@common/assets/removeIcon";

function SelectedResource({ resource, removeSelectedResource }: Props) {
  return (
    <div className={styles.selectedResource}>
      <div className={styles.resource}>
        <div className={styles.icon}>
          <ResourceAvatar resource={resource} />
        </div>
        <p>{resource.name}</p>
      </div>
      <div
        className={styles.removeButton}
        onClick={() => removeSelectedResource(resource)}
      >
        <RemoveIcon className={styles.removeIcon} />
      </div>
    </div>
  );
}

export { SelectedResource };
